// extracted by mini-css-extract-plugin
export default {"nameColumn":"_3Ym_i","nameContainer":"_1sHpf","row":"_2hNH1","total":"_2pPKD","overflow":"_1Nb08","tooltip":"kccf8","divider":"_1dNfu"};